import React, { lazy } from 'react'
import { Route } from 'react-router-dom';
import ProviderRegister from '../pages/Login/ProviderRegister';
const Login = lazy(() => import('../pages/Login/Login.js'));
const GoogleSucceed = lazy(() => import('../pages/Login/GoogleResponse.js'));
const ForgetPassword = lazy(() => import('../pages/Login/ForgetPassword.js'));
const SelectRole = lazy(() => import('../pages/Login/SelectRole.js'));
const ResetPassword = lazy(() => import('../pages/Login/ResetPassword.js'));
const Home = lazy(() => import('../pages/Home/Home'));

// ── PUBLIC DRAFT TOURNAMENT PAGE (NEW) ────────────────────────────────────────
// This route is PUBLIC — no auth required.
// If the user IS logged in, the page detects it and pre-fills their info.
const DraftTournamentPublicPage = lazy(() => import('../pages/DraftTournament/DraftTournamentPublicPage.jsx'));
const BracketViewPage = lazy(() => import('../components/Bracket/BracketViewPage.jsx'));

// ── PUBLIC TOURNAMENT PAGE ─────────────────────────────────────────────────────
// /tournament/quakes-series-ii  or  /tournament/11  — no auth required.
const TournamentPublicPage = lazy(() => import('../pages/Public/TournamentPublic/TournamentPublicPage.jsx'));

const GlobalRoutes = (
    <>
        <Route exact path='/' element={<Home />}></Route>
        <Route exact path='/auth/register' element={<ProviderRegister />}></Route>
        <Route exact path='/auth/google-succeed' element={<GoogleSucceed />}></Route>
        <Route exact path='/auth/select-role' element={<SelectRole />}></Route>
        <Route exact path='/auth/login' element={<Login />}></Route>
        <Route exact path='/auth/forget-password' element={<ForgetPassword />}></Route>
        <Route exact path='/auth/reset-password' element={<ResetPassword />}></Route>
        <Route exact path='/bracket-view/:bracketId' element={<BracketViewPage />} />

    {/* ── Draft public registration page ──────────────────────────────── */}
    {/* URL: /draft/summer-classic-2025 */}
    <Route exact path='/draft/:slug' element={<DraftTournamentPublicPage />} />        

    {/* ── Team tournament public page (tabs: info, games, venue, …) ─────── */}
    <Route exact path='/tournament/:key' element={<TournamentPublicPage />} />


    </>
)

export default GlobalRoutes